<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>User List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form [formGroup]="EditUser">
                            <div class="mb-3">

                                <button class="btn btn-primary me-1 mb-3" style="float: right;"
                                        (click)="moveToMainPage()">Back
                                </button>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>Id</label>
                                <input type='text' class="filter-ngx form-control" formControlName="id">

                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Username</label>
                                <input type='text' class="filter-ngx form-control" placeholder='username'
                                       formControlName="username">

                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Mobile Number</label>
                                <input type='text' class="filter-ngx form-control" placeholder='mobilenumber'
                                       formControlName='mobilenumber'>

                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>API ID</label>
                                <input type='text' class="filter-ngx form-control" placeholder='API ID'
                                       formControlName='api_id'>

                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>API Key</label>
                                <input type='text' class="filter-ngx form-control" placeholder='API Key'
                                       formControlName='api_hash'>

                            </div>

                            <label>Status<span class="text-danger">*</span></label>
                            <select class="form-select form-control" formControlName="status">
                                <option [ngValue]="1">Enable</option>
                                <option [ngValue]="0">Disable</option>
                                <option *ngFor="let item of status"
                                        [ngValue]="item.status">{{item.status}}</option>
                            </select>
                            <br>
                            <label>Blocked Message<span class="text-danger">*</span></label>
                            <select class="form-select form-control" formControlName="blocked_message">
                                <option [ngValue]="1">Yes</option>
                                <option [ngValue]="0">No</option>
                                <option *ngFor="let item of blocked_add_channel">
                                    [ngValue]="item.blocked_message">{{item.blocked_message}}</option>
                            </select>
                            <br>
                            <label>Blocked Add Channel<span class="text-danger">*</span></label>
                            <select class="form-select form-control" formControlName="blocked_add_channel">
                                <option [ngValue]="1">Yes</option>
                                <option [ngValue]="0">No</option>
                                <option *ngFor="let item of blocked_add_channel">
                                    [ngValue]="item.blocked_add_channel">{{item.blocked_add_channel}}</option>
                            </select>
                            <br>
                            <div>
                                <button class="btn btn-primary me-1 mb-3" style="float: right;"
                                        (click)="updateEditUser()">
                                    Save
                                </button>
                            </div>
                            <div class="clearfix"></div>


                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>

